import { updateSelectedAnswerSuccess, updateSearchResultsSuccess } from 'app/modules/self_service';

export default class SelfServiceGatewayObserver {
  constructor(context) {
    this.context = context;
  }

  handleError({ reason, err }) {
    console.log(`gateway encountered an error. ${reason}: ${err}`);
  }

  handleUpdateSelectedAnswerSuccess(answer) {
    this.context.executeAction(updateSelectedAnswerSuccess(answer));
  }

  handleUpdateSearchResults(answers) {
    this.context.executeAction(updateSearchResultsSuccess(answers));
  }
}
